import { FC } from 'react';

import { Typography } from '@/components/shared/Typography';

import css from './style.module.scss';

interface Tag {
	id: number;
	name: string;
}

interface Props {
	tags: Tag[];
}

const CardTags: FC<Props> = ({ tags }) => (
	<ul className={css.cardTags}>
		{tags.map(tag => (
			<Typography key={tag.id} variant="body-s" tag="li" className={css.tag}>
				{tag.name}
			</Typography>
		))}
	</ul>
);

export default CardTags;
